import axios from 'axios'

// this.$store.state['message/messagesInitialized']
const state = () => ({
    ////////////////////////////////////////////////
    // start repeating timed functions
    ////////////////////////////////////////////////
    messageJob: null,
    ////////////////////////////////////////////////
    // end repeating timed functions
    ////////////////////////////////////////////////
    ////////////////////////////////////////////////
    // start message center
    ////////////////////////////////////////////////
    messages: [],
    ////////////////////////////////////////////////
    // end message center
    ////////////////////////////////////////////////
    messagesInitialized: false,
})

const POLL_FREQUENCY = 60000

// this.$store.getters['message/messages']
const getters = {
    ////////////////////////////////////////////////
    // start getters message center
    ////////////////////////////////////////////////
    messagesInitialized: (state, getters, rootState, rootGetters) => {
        return state.messagesInitialized
    },
    messages: (state, getters, rootState, rootGetters) => {
        return state.messages
    },
    messageCount: (state, getters, rootState, rootGetters) => {
        return getters.messages.length
    },
    hasMessages: (state, getters, rootState, rootGetters) => {
        return getters.messages.length > 0
    },


    unreadMessages: (state, getters, rootState, rootGetters) => {
        // console.log('vuex getters unreadMessages')

        const messages = state.messages
        const unreadMessages = messages.filter(message => {
            let messageIsUnread = message.isRead === false
            // console.log('vuex actions messagesUnread message', message)
            // console.log('vuex actions messagesUnread messageIsUnread', messageIsUnread)
            return messageIsUnread
        })
        return unreadMessages
    },
    unreadMessageCount: (state, getters, rootState, rootGetters) => {
        // console.log('vuex getters unreadMessageCount')
        return getters.unreadMessages.length
    },
    hasUnreadMessages: (state, getters, rootState, rootGetters) => {
        // console.log('vuex getters hasUnreadMessages')
        return getters.unreadMessages.length > 0
    },

    messageJob: (state, getters, rootState, rootGetters) => {
        return state.messageJob
    },

    ////////////////////////////////////////////////
    // end getters message center
    ////////////////////////////////////////////////

}

// $store.dispatch('auth/authRedirect')
const actions = {

    ////////////////////////////////////////////////
    // start actions message center
    ////////////////////////////////////////////////
    startMessagesJob: ({ commit, state, getters, dispatch }) => {
        console.log('vuex actions startMessagesJob')
        let messageJob = setInterval(() => {
            dispatch('getMessages')
        }, POLL_FREQUENCY)
        // console.log('vuex actions startMessagesJob messageJob', messageJob)
        commit('SET_MESSAGE_JOB', messageJob)
        // console.log('vuex actions startMessagesJob context.getters.messageJob', getters.messageJob)
    },
    stopMessagesJob: ({ commit, state, getters, dispatch }) => {
        console.log('vuex actions stopMessagesJob', getters.messageJob)
        clearInterval(getters.messageJob)
        commit('SET_MESSAGE_JOB', null)
        commit('SET_MESSAGES_INITIALIZED', false)
    },
    getMessages: ({ commit, state, getters, dispatch }) => {
        // console.log('vuex actions getMessages')
        let apiEndpoint = '/messages'

        axios.get(apiEndpoint)
            .then(response => {
                // console.log('VUEX actions getMessages then', response)
                let responseData = response.data
                responseData = responseData.map(message => {
                    return {
                        ...message,
                        _key: `message-list-item-${ message.uuid }`,
                    }
                })
                commit('SET_MESSAGES', responseData)
            })
            .catch(error => {
                // console.log('VUEX actions getMessages catch', error)
            })
            .finally(() => {
                commit('SET_MESSAGES_INITIALIZED', true)
            })

    },
    ////////////////////////////////////////////////
    // end actions message center
    ////////////////////////////////////////////////

}

// $store.commit('auth/SET_JWT', response.data)
const mutations = {
    ////////////////////////////////////////////////
    // start mutations message center
    ////////////////////////////////////////////////
    SET_MESSAGES: (state, payload) => {
        // console.log('vuex mutations SET_MESSAGES')
        state.messages = payload
    },
    SET_MESSAGES_INITIALIZED: (state, payload) => {
        // console.log('vuex mutations SET_MESSAGES_INITIALIZED')
        state.messagesInitialized = payload
    },
    SET_MESSAGE_JOB: (state, messageJob) => {
        // console.log('vuex mutations SET_MESSAGE_JOB')
        state.messageJob = messageJob
    },
    // TOGGLE_ALERTS: (state) => {
    //   state.showAlerts = !state.showAlerts
    // },
    // SET_ALERT: (state, alert) => {
    //   console.log('vuex mutations SET_ALERT')
    //   state.alert = alert
    // },
    ////////////////////////////////////////////////
    // end mutations message center
    ////////////////////////////////////////////////

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}

